import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import store from './store'

import '@/assets/style/jquery.fancybox.css'
import '@/assets/style/owl.carousel.min.css'
import '@/assets/style/owl.theme.default.min.css'
import '@/assets/style/owl.theme.green.min.css'
import '@/assets/style/style.css'
import '@/assets/style/responsive.css'
import '@/assets/style/manifiesto.css'

import '@/assets/js/jquery.fancybox.min.js'
import '@/assets/js/owl.carousel.min.js'
import '@/assets/js/main.js'

Vue.config.productionTip = false
// axios.defaults.baseURL = 'http://67.205.156.112:4000'
// axios.defaults.baseURL = 'http://157.230.229.234:3037' // same as the Url the server listens to
// axios.defaults.baseURL = 'http://157.230.229.234:3037' // same as the Url the server listens to
// axios.defaults.baseURL = 'http://157.230.229.234:3037'
axios.defaults.baseURL = 'https://api.grupofelix.northwest.mx/'
/* axios.defaults.baseURL = 'https://143.198.128.63:8080' */
axios.defaults.baseURL = 'https://fasaip.ddns.net:9080/'
Vue.prototype.$http = axios
// Vue.prototype.API_URL = 'http://143.110.239.9'
Vue.prototype.API_URL = 'https://api.grupofelix.northwest.mx'
/* Vue.prototype.API_URL = 'https://143.198.128.63:8080' */
// localStorage.setItem('suc', 1)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
